import { IAPIActionBase } from "us.common/interfaces";
import { UniQActions } from "us.common/constants";

const {
  SEND_MESSAGE,
  SEND_MESSAGE_SUCCESS,
  SEND_MESSAGE_FAIL,
  RESET_MESSAGE,
  SET_MESSAGES,
  RESET_MESSAGES,
  SET_MESSAGES_SUCCESS,
  SET_MESSAGES_FAIL,
  HANDLE_SETTINGS_POPOVER,
  SAVE_DEFAULT_PROMPT,
  SAVE_DEFAULT_PROMPT_SUCCESS,
  SAVE_DEFAULT_PROMPT_FAIL,

  GET_DEFAULT_PROMPT,
  GET_DEFAULT_PROMPT_SUCCESS,
  GET_DEFAULT_PROMPT_FAIL,
  RESET_SESSION,
  RESET_SESSION_SUCCESS,
  RESET_SESSION_FAIL,
} = UniQActions;

export const uniQActions: Readonly<IAPIActionBase> = {
  message: {
    save: (data) => ({
      type: SEND_MESSAGE,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: SEND_MESSAGE_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: SEND_MESSAGE_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
    reset: () => ({
      type: RESET_MESSAGE,
      payload: {
        data: {},
        isLoading: true,
      },
    }),
  },
  messages: {
    set: () => ({
      type: SET_MESSAGES,
      payload: {
        data: [],
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: SET_MESSAGES_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: SET_MESSAGES_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
    reset: (data) => ({
      type: RESET_MESSAGES,
      payload: {
        data: data || [],
        isLoading: true,
      },
    }),
  },
  defaultPrompt: {
    save: (data) => ({
      type: SAVE_DEFAULT_PROMPT,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: SAVE_DEFAULT_PROMPT_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: SAVE_DEFAULT_PROMPT_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
    handlePopover: (data) => ({
      type: HANDLE_SETTINGS_POPOVER,
      payload: {
        data: data || [],
        isLoading: true,
      },
    }),
  },
  defaultPromptData: {
    get: (data) => ({
      type: GET_DEFAULT_PROMPT,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_DEFAULT_PROMPT_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_DEFAULT_PROMPT_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
    reset: (data) => ({
      type: RESET_MESSAGES,
      payload: {
        data: data || [],
        isLoading: true,
      },
    }),
  },
  session: {
    reset: (data) => ({
      type: RESET_SESSION,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: RESET_SESSION_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: RESET_SESSION_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
};
